// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonGroup_buttons__9xPBd","fixedWidth":"ButtonGroup_fixedWidth__GCt6D"};